import { gql as n } from "@apollo/client";
import { LoginAccountFragment as t } from "../fragment/account.js";
const u = n`
  mutation LoginByOAuth(
    $input: LoginByOAuthInput!
    $fingerprintInput: FingerprintInput
  ) {
    loginByOAuth(input: $input, fingerprintInput: $fingerprintInput) {
      ...LoginAccount
    }
  }

  ${t}
`;
export {
  u as default
};
//# sourceMappingURL=loginByOAuth.js.map
